import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Row } from "react-flexbox-grid";

import YoutubeIcon from "./youtube";
import InstagramIcon from "./instagram";
import FacebookIcon from "./facebook";
import LinkedinIcon from "./linkedin";
import TwitterIcon from "./twitter";

import * as styles from "./styles.module.css";

const SocialMediaIcon = ({ type }) => {
  if (!type) {
    return null;
  }
  if (type.toLowerCase().includes("facebook")) {
    return <FacebookIcon />;
  }
  if (type.toLowerCase().includes("linkedin")) {
    return <LinkedinIcon />;
  }
  if (type.toLowerCase().includes("youtube")) {
    return <YoutubeIcon />;
  }
  if (type.toLowerCase().includes("instagram")) {
    return <InstagramIcon />;
  }
  if (type.toLowerCase().includes("twitter") || type.toLowerCase() === "x") {
    return <TwitterIcon />;
  }
  return null;
};

const SocialMediaRow = ({ sections }) => {
  return (
    <Row>
      {sections?.map((i) => (
        <Col
          md={3}
          key={i}
          className="p0 socialMediaCol"
          data-position={i.position}
          data-title={i.caption.value}
        >
          <div className={styles.fullcontainer}>
            <GatsbyImage
              image={getImage(i.r.img.r.field_image.localFile)}
              alt={i.r.img.field_image.alt}
              style={{ maxHeight: "400px" }}
              imgStyle={{ objectFit: "fill" }}
            />
            <div className={styles.socialIcon}>
              <SocialMediaIcon type={i.source} />
            </div>
            <div className={styles.overlay}>
              <div className={styles.bodycontent}>
                <p>{i.caption.value}</p>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = `${i.link.uri}`;
                  }}
                  target="_blank"
                  className={styles.buttonStyled}
                  data-clicklink={i.link.uri}
                >
                  {i.link.title}
                </button>
              </div>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default SocialMediaRow;
